import { useEffect } from 'react'
import Container from '@mui/material/Container'
import { useTranslation } from 'react-i18next'
import HelmetMeta from '../../layouts/HelmetMeta.js'

export default function Terms () {
  const { t } = useTranslation('legals')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <HelmetMeta
        {...{
        title: t('terms.metaTitle'),
        description: t('terms.metaDescription'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      <div>
        <br /><br /><br /><br />
        <h1>{t('terms.heading')}</h1>
        <h2>{t('terms.s1Heading')}</h2>
        <p>
          {t('terms.s1p1Before')}
          <a style={{ color: 'orange' }} href='https://www.peakssports.com' target='_blank'>peakssports.com</a>
          {t('terms.s1p1After')}
        </p>
        <h2>{t('terms.s2Heading')}</h2>
        <ol type='a'>
          <li>
            {t('terms.s2li1')}
            <ol type='i'>
              <li>{t('terms.s2li1a')}</li>
              <li>{t('terms.s2li1b')}</li>
              <li>{t('terms.s2li1c')}</li>
              <li>{t('terms.s2li1d')}</li>
              <li>{t('terms.s2li1e')}</li>
            </ol>
          </li>
          <li>{t('terms.s2li2')}</li>
        </ol>
        <h2>{t('terms.s3Heading')}</h2>
        <ol type='a'>
          <li>{t('terms.s3li1')}</li>
          <li>{t('terms.s3li2')}</li>
        </ol>
        <h2>{t('terms.s4Heading')}</h2>
        <p>{t('terms.s4p1')}</p>
        <h2>{t('terms.s5Heading')}</h2>
        <p>{t('terms.s5p1')}</p>
        <h2>{t('terms.s6Heading')}</h2>
        <p>
          {t('terms.s6p1Before')}
          <a style={{ color: 'orange' }} href='https://www.peakssports.com' target='_blank'>peakssports.com</a>
          {t('terms.s6p1After')}
        </p>
        <h2>{t('terms.s7Heading')}</h2>
        <p>{t('terms.s7p1')}</p>
        <h2>{t('terms.s8Heading')}</h2>
        <p>{t('terms.s8p1')}</p>
      </div>
    </Container>
  )
}
